webpackJsonp([172411548396689],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "head" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement("img", {
	          src: "https://s3-eu-west-1.amazonaws.com/web-designio/website-dan/img/dan-logo.png",
	          alt: "DAN EV - Dienst am N\xE4chsten",
	          className: "logo"
	        }),
	        _react2.default.createElement(
	          "span",
	          {
	            id: "global-slogan",
	            "data-editable": "simpletext",
	            className: "slogan",
	            "data-global": "data-global"
	          },
	          "Nachbarschaftshilfe",
	          _react2.default.createElement("br", null),
	          "von Mensch zu Mensch"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "hotline" },
	          _react2.default.createElement(
	            "strong",
	            {
	              id: "global-fragen",
	              "data-editable": "simpletext",
	              "data-global": "data-global"
	            },
	            "Sie haben Fragen?"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "span",
	            {
	              id: "global-phone",
	              "data-editable": "simpletext",
	              "data-global": "data-global"
	            },
	            "0174/3444893",
	            _react2.default.createElement("br", null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "nav" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "ul",
	          { className: "clearfix" },
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/home" },
	              "Startseite"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/geschichte" },
	              "Geschichte"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/dienstleistungen" },
	              "Dienstleistungen"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/sie-wollen-helfen" },
	              "Sie wollen helfen?"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/mitglieder" },
	              "Mitglieder"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "/kontakt" },
	              "Kontakt"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "content" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "h1",
	          { id: "impressum", "data-editable": "simpletext" },
	          "Impressum"
	        ),
	        _react2.default.createElement(
	          "p",
	          { id: "adresse", "data-editable": "simpletext" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Dienst am N\xE4chsten e.V.\xA0",
	            _react2.default.createElement("br", null),
	            " Clarissenstr. 11 \xA0",
	            _react2.default.createElement("br", null),
	            " 89077 Ulm\xA0"
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { id: "table", "data-editable": "text" },
	          _react2.default.createElement(
	            "table",
	            { cellPadding: 1, cellSpacing: 0, style: { width: '30%' } },
	            _react2.default.createElement(
	              "tbody",
	              null,
	              _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  "Email:"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    { href: "mailto:info@dan-ev.de" },
	                    "info@dan-ev.de"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "p",
	          { id: "content", "data-editable": "text" },
	          "1. Vorsitzender: Gerhard Fischer; Gesch\xE4ftsf\xFChrung: Andreas Baier\xA0",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          " Haftungshinweis:\xA0",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          " Alle Inhalte dieser Internet Seiten, werden mit sorgf\xE4ltiger inhaltlicher Kontrolle recherchiert. Gleichwohl \xFCbernimmt der Dienst am N\xE4chsten e.V. keine Haftung f\xFCr die Richtigkeit, Vollst\xE4ndigkeit und Aktualit\xE4t der bereitgestellten Informationen. Alle Inhalte externer Links unterliegen der Haftung der jeweiligen Anbieter. F\xFCr die Inhalte externer Links \xFCbernehmen wir keine Haftung. F\xFCr die Inhalte der verlinkten Seiten sind ausschlie\xDFlich deren Betreiber verantwortlich."
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-impressum-js-11613b18f0d2962ee6cc.js